export const HOST_URL = process.env.REACT_APP_API_HOST
export const HTTP_GET = `GET`
export const HTTP_PUT = `PUT`
